import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import { toast } from "react-toastify";

import { useForm } from "react-hook-form";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../../components/Component";
import MySelect from "../../../MyComp/UI/form/MySelect";
import MyInput from "../../../MyComp/UI/form/MyInput";

import DeleteModal from "../../../MyComp/UI/modals/DeleteModal";
import ConfirmModal from "../../../MyComp/UI/modals/ConfirmModal";
import MyButton from "../../../MyComp/UI/form/MyButton";
import useLogout from "../../../hooks/useLogout";
import ViewImgAndPdf from "../../ImageFolder/ViewImageAndPdf";
import MyDataTable from "../../../MyComp/UI/DataTable/MyDataTable";
import Status from "../../../MyComp/UI/form/Status";
import { BASE_URL_IMG } from "../../../assets/constants";
import { UserAvatarCell } from "../../../MyComp/ImageView/UserAvatarCell";
import {
  createGroupAPI,
  createPackageAPI,
  deletePackageAPI,
  deleteTestCategory,
  getPackageListAPI,
  listGroupAPI,
  updateGroupAPI,
  updatePackageAPI,
  uploadTestCatalog,

} from "../../../api/master/indes";
import { categoryTestDDAPI, subMultipleCategoryDDAPI } from "../../../api/dropdown";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
const LabGroup = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
   const {
    clearErrors: clearErrorsTest,
    register: registerTest,
    handleSubmit: handleSubmitTest,
    control: controlTest,
    setValue: setValueTest,
    watch: watchTest,
    trigger: triggerTest,
    formState: { errors: errorsTest },
    reset: resetTest,
   setError: setErrorTest
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
    mode: "onChange",
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Table Columns
  const [column, setColumn] = useState([
   
    {
      name: "Image",
      selector: (row) => (
        <div  >
          {/* <img
            style={{ width: "50px", height: "50px", borderRadius: "6px" }}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
          /> */}
           <UserAvatarCell row={row} name={row?.category} handleImageOpenPreview={handleImageOpenPreview} image={`${BASE_URL_IMG}${row.image}`}/>
          
        </div>
      ),
      sortable: false,
      wrap: true,
    },
     {
      name: "Group Name",
      selector: (row) => row?.category,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
           <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);

  // Fetch group list
  useEffect(() => {
    getGroupList();
  }, []);

  const getGroupList = async () => {
    try {
      const res = await listGroupAPI();
      if (res.data.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } else if (res.data.status === true) {
        setValue("data", res.data.data);
      } else {
        setValue("data", []);
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
    }
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const onFormSubmit = async (data) => {
    console.log(data,"dataaa")
    try {
      setValue("isLoading", true);
      const formData = new FormData();

      formData.append("status", watch("status")?.value);
      const i = watch("group_img");
      if (data?.group_img) {
        formData.append("image", i);
      }

      if (watch("addSub")) {
        formData.append("parent_id", data?.sub_disease ? data?.sub_disease?.value : watch("selectedRow")?.id);
        formData.append("name", watch("subdisease"));
      } else {
        formData.append("name", watch("name"));
      }

      if (mode === "Edit") {
        formData.append("id", watch("selectedRow")?.id);
      }

      let res;
      if (mode === "Add") {
        res = await createGroupAPI(formData);
      } else {
        res = await updateGroupAPI(formData);
      }

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        toast.clearWaitingQueue();
        await getGroupList();
        getGroupList();
           setMode("Add");
        resetF();
        
        setIsOpen(false);
      } else if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        logout();
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setValue("isLoading", false);
    }
  };

 const handleEdit = (row) => {
  window.scrollTo(0, 0);

  setMode("Edit");
  setIsOpen(true);

//   reset({
    setValue("name", row?.category || "");
    setValue("status", {
      label: row?.status ? "Active" : "Inactive",
      value: row?.status,
    });
    setValue("group_image", `${BASE_URL_IMG}${row?.image}`); // preview URL
    setValue("group_img", null); // FILE must be null
    setValue("addSub", false);
    setValue("selectedRow", row);
//   });
};
console.log(errors,"errors")
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
    //   id: watch("selectedRow").id,
    //api not available for status change in group using id
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getGroupList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
   
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const handleSubdiseaseClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setValue("group", row?.name);
    setValue("group_image", row.image);
    setValue("group_img", row.image);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };
const [loading, setLoading] = useState(false);
  const resetF = () => {
    setValue("group_image", null);
    setValue("group", "");
    setValue("name", "");
    setValue("status", null);
    setValue("addSub", false);
    setValue("group_img", null);
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
     setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    setLoading(true);

    deleteTestCategory({ id: watch("selectedRow").id })
      .then((res) => {
        setLoading(false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
        //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
        setValue(
  "data",
  watch("data").filter(
    (item) => item.id !== watch("selectedRow")?.id
  )
);

        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  
    const handleUploadClick = () => {
      setDownloadModalOpen(true);
    };
      const labId = localStorage.getItem("userId");
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    // New: Handle Upload click to show download modal
    const uploadTestCatalogAPI = async () => {
      try {
        setUploading(true);
        const file = watchTest("file");
        if (!file) {
          toast.errorsTest("Please select an Excel file");
          return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("labId", labId);
  
        const res = await uploadTestCatalog(formData);
  
        if (res?.data?.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res?.data?.status === true) {
          toast.success(res.data.message || "Excel uploaded successfully");
          handleCancel();
          setDownloadModalOpen(false);
          setValueTest("data", res.data.data || []);
        } else {
          toast.error(res?.data?.message || "Upload failed");
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Upload failed");
      } finally {
        setUploading(false);
      }
    };
  
    const handleChange = (e) => {
      const selectedFile = e.target.files[0];
  
      if (!selectedFile) {
        setValueTest("file", null);
        setErrorTest("file", { type: "manual", message: "File is required" });
        return;
      }
  
      validateExcel(selectedFile, (isValid) => {
        if (isValid) {
          clearErrorsTest("file");
          setValueTest("file", selectedFile);
        } else {
          setValueTest("file", null);
          setErrorTest("file", { type: "manual", message: "Invalid file type. Please upload a valid Excel file." });
          toast.error("Invalid file type. Please upload a valid Excel file.");
          e.target.value = null;
        }
      });
    };
    useEffect(() => {
      if (!downloadModalOpen) {
        setValueTest("file", null);
        clearErrors("file");
  
        // reset actual file input DOM value
        const input = document.getElementById("fileInput");
        if (input) {
          input.value = "";
        }
      }
    }, [downloadModalOpen]);
    const handleCancel = () => {
      setValueTest("file", null);
      clearErrors("file");
  
      const input = document.getElementById("fileInput");
      if (input) {
        input.value = "";
      }
    };
  
    // const handleCancel = () => {
    //   setValue("file", null);
    //   clearErrors("file");
    // };
    const validateExcel = (file, callback) => {
      const reader = new FileReader();
  
      const fileName = file.name.toLowerCase();
      const isXlsExtension = fileName.endsWith(".xls");
      const isXlsxExtension = fileName.endsWith(".xlsx");
  
      if (!isXlsExtension && !isXlsxExtension) {
        callback(false);
        return;
      }
  
      reader.onloadend = function (event) {
        const arr = new Uint8Array(event.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16).padStart(2, "0");
        }
        header = header.toUpperCase();
  
        const isXls = header === "D0CF11E0"; // XLS
        const isXlsx = header === "504B0304"; // XLSX
        const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);
  
        callback(isExcel);
      };
  
      reader.onerror = function () {
        callback(false);
      };
  
      reader.readAsArrayBuffer(file.slice(0, 4));
    };
    const [uploading, setUploading] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
  
  
    const handleSampleFileOpen = () => {
      const upload = "upload-test-catalog";
      const fileName = `${BASE_URL_IMG}${upload}`;
      // Replace 'sample_file.txt' with the name of your sample file
      // const fileName = watch("file_name");
      var filePath;
      // Path to your sample file
      // if (selectedType?.value == "facility") {
      filePath = ` ${watch("file_name")}`; // Update the path
      // } else {
      //   filePath = `${base}${sampelFileV2}`; // Update the path
      // }
      const link = document.createElement("a");
      link.href = filePath;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  return (
    <>
      <Head title="Group | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Group
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent><>
                 {/* <Button color="primary" outline style={{ marginRight: "15px" }} onClick={handleUploadClick}>
                  <Icon name="upload" />
                </Button> */}
                {mode === "Edit" && (  <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  setIsOpen((pre) => !pre);
                  setMode("Add");
                  resetF();
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>)}</>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard className="mb-2">
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Group Name"
                      name="name"
                      placeholder="Enter group name"
                      required
                      readonly
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>

                  <Col md="4">
                    <ImageUpload
                      name="group_image"
                      id="group_image"
                      watch={watch}
                      label="Upload Group Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="group_img"
                           setError={setError}
                      image_url="group_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>

                  <Col md="4">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title="Group List" isLoading={isLoading} />
        </Block>
      </Content>
 <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={loading}
      />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
<Modal isOpen={downloadModalOpen} toggle={() => setDownloadModalOpen(false)} centered>
        <ModalHeader toggle={() => setDownloadModalOpen(false)}>Upload Test Catalog (Excel)</ModalHeader>

        <ModalBody>
          <div className="d-block justify-content-between">
            <div
              style={{
                // maxWidth:'250px',
                border: "2px dashed #cfd4da",
                borderRadius: "10px",
                padding: "5px",
                textAlign: "center",
                background: "#f8f9fa",
              }}
            >
              {watchTest("file") ? (
                <div
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "10px",
                    padding: "20px",
                    background: "#ffffff",
                  }}
                >
                  <Icon name="file-excel" style={{ fontSize: "28px", color: "green" }} />
                  <p
                    style={{
                      marginTop: "10px",
                      wordBreak: "break-word",
                      fontWeight: "600",
                    }}
                  >
                    {watchTest("file")?.name}
                  </p>

                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <Button color="danger" size="sm" className="p-2" outline onClick={handleCancel}>
                      Remove
                    </Button>
                    <Button
                      className="p-2"
                      color="primary"
                      size="sm"
                      disabled={uploading}
                      onClick={uploadTestCatalogAPI}
                    >
                      {/* {uploading ? "Uploading..." : "Upload"} */}
                      {"Upload"}
                    </Button>
                  </div>
                </div>
              ) : (
                /* FILE INPUT */
                <>
                  <label
                    htmlFor="fileInput"
                    style={{
                      cursor: "pointer",
                      display: "block",
                    }}
                  >
                    <Icon name="upload" style={{ fontSize: "30px", color: "#0d6efd" }} />
                    <p style={{ marginTop: "5px", fontWeight: "500" }}>Click to upload test catalog</p>
                    {/* <small style={{ color: "#6c757d" }}>
              Supported formats: .xls, .xlsx
            </small> */}
                  </label>

                  <input
                    type="file"
                    id="fileInput"
                    accept=".xls,.xlsx"
                    style={{ display: "none" }}
                    {...registerTest("file", { requiredTest: "File is required" })}
                    onChange={handleChange}
                  />

                  {errorsTest.file && (
                    <div style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>{errorsTest.file.message}</div>
                  )}
                </>
              )}
            </div>

            {/* SAMPLE DOWNLOAD */}
            {/* <div
              style={{
                border: "2px,solid,lightgray",
                borderRadius: "10px",
                paddingLeft: "50px",
                marginBottom: "10px",
                paddingTop: "15px",
                paddingRight: "25px",
                paddingBottom: "15px",
                marginTop: "10px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                alignItems: "center",
              }}
            >
              <small style={{ color: "crimson" }}>Download sample Excel</small>

              <Button size="sm" color="primary" outline onClick={handleSampleFileOpen}>
                <Icon name="download" /> Sample
              </Button>
            </div> */}
          </div>
        </ModalBody>
      </Modal>
      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default LabGroup;
